import partnerService from '../api/partner'

const state = {
    partners: [],
    classifiedList: []
}

const getters = {

}

const actions = {
    search({commit, state}) {
        const requestId = 'SEARCH_PARTNER'

        return partnerService.search().then(response => {
            const result = response.data
            const partners = result.data ? result.data : result
            commit('setPartners', partners)

            return partners
        }, () => false).finally(() => commit('ui/disableLoader', requestId, {root: true}))
    }
}

const mutations = {
    setPartners(state, partners) {
        state.partners = partners
            /*.sort(function (a, b) {
            return a.compare.toLowerCase().localeCompare(b.compare.toLowerCase(), 'fr', { sensitivity: 'base'})
        })*/
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
